<template>
  <div class="space-y-8 mx-auto sm:px-6 lg:px-8 bg-base-200 sm:p-8 rounded-3xl shadow-xl">
    <HeroHeader :score="totalScore" :summaryKey="summaryKey" :headlineKey="headlineKey" />

    <PlanSelectionCard class="animate-slideUp" />

    <SummarySections
      :sections="schema"
      :answers="answers"
      :hovering="hovering"
      @navigate="navigateToSection"
      @update:hovering="val => (hovering = val)" />

    <CallToAction @email="openEmailClient" :t="t" />
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref } from "vue";
import PlanSelectionCard from "@/features/planSelection/PlanSelectionCard.vue";
import HeroHeader from "@/features/blueprint/components/summary/HeroHeader.vue";
import SummarySections from "@/features/blueprint/components/summary/SummarySections.vue";
import CallToAction from "@/features/blueprint/components/summary/CallToAction.vue";
import { useBlueprintSummary } from "@/features/blueprint/composables/useBlueprintSummary";
import { QuestionSchema } from "@/features/blueprint/schema/questions/QuestionSchema";
import { Answers } from "@/features/blueprint/schema/answers/Answers";

const props = defineProps<{ answers: Answers; schema: QuestionSchema[] }>();
const hovering = ref<number | null>(null);

const blueprint = useBlueprintSummary(props.answers);
const { t, totalScore, summaryKey, headlineKey, navigateToSection, openEmailClient } = blueprint;
</script>

<style>
@keyframes wiggle {
  0%,
  100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-5deg);
  }
  75% {
    transform: rotate(5deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animate-fadeIn {
  animation: fadeIn 0.5s ease-out;
}
.animate-slideUp {
  animation: slideUp 0.6s ease-out;
}
.wiggle {
  animation: wiggle 0.4s ease-in-out;
}

details > summary:focus {
  outline: 2px dashed var(--pf-global--palette--purple-500);
  outline-offset: 4px;
}
</style>
